<template>
  <div class="account">
    <div class="hero is-fullheight">
      <section class="section">
        <div class="container">


        <h4 class="title page-title has-text-centered has-padding-v-50 is-4"><b>{{ supplier.companyName }}</b><br><small>Marketplace Account</small></h4>
        <div class="columns">
          <div class="column account__edit">
            <div class="account__edit-item">
              <editable-item component="editable-image" v-model="supplier.logo" title="Logo" @isEditView="true"></editable-item>
            </div>
            <div class="account__edit-item">
              <div class="columns is-mobile">
                <div class="column account__edit-content">
                    <input class="input" type="text" id="thisTrading_input" v-model="thisTradingClean" v-if="editingTrading == true" style="width:100%" />
                    <span v-html="thisTrading" id="thisTrading_value" v-else></span>
                </div>
                <div class="column account__edit-link__wrapper is-two-fifths" v-if="editingTrading == true">
                  <a class="account__edit-link is-warning" @click.prevent="editingTrading = false">Cancel</a> |
                  <a class="account__edit-link is-success" @click.prevent="editTradingSave">Save</a>
                </div>
                <div class="column account__edit-link__wrapper is-two-fifths" v-else><a class="account__edit-link" @click.prevent="editTrading">Edit Company Trading Name</a></div>
              </div>
            </div>
            <div class="account__edit-item">
              <div class="columns is-mobile">
                <div class="column account__edit-content">
                    <input class="input" type="text" id="thisAddress_input" v-model="thisAddressClean" v-if="editing == true" style="width:100%" />
                    <span v-html="thisAddress" id="thisAddress_value" v-else></span>
                </div>
                <div class="column account__edit-link__wrapper is-two-fifths" v-if="editing == true">
                  <a class="account__edit-link is-warning" @click.prevent="editing = false">Cancel</a> |
                  <a class="account__edit-link is-success" @click.prevent="editAddressSave">Save</a>
                </div>
                <div class="column account__edit-link__wrapper is-two-fifths" v-else>
                  <a class="account__edit-link" @click.prevent="editAddress">Edit Company Address</a>
                </div>
              </div>
            </div>
            <div class="account__edit-item">
                <div class="columns is-mobile">
                    <div class="column account__edit-content">
                        <div v-if="supplier.authorised && supplier.authorised.email">
                            {{ supplier.authorised.name }}<br>
                            {{ supplier.authorised.jobTitle }}<br>
                            {{ supplier.authorised.email }}<br>
                            {{ supplier.authorised.phone }}
                        </div>
                    </div>
                    <div class="column account__edit-link__wrapper is-two-fifths"><a class="account__edit-link" @click.prevent="$router.push('/contact/authorised')">Edit Authorised Contact</a></div>
                </div>
            </div>
            <div class="account__edit-item">
                <div class="columns is-mobile">
                    <div class="column account__edit-content">
                        <div v-if="supplier.general && supplier.general.email">
                            {{ supplier.general.name }}<br>
                            {{ supplier.general.jobTitle }}<br>
                            {{ supplier.general.email }}<br>
                            {{ supplier.general.phone }}
                        </div>
                    </div>
                    <div class="column account__edit-link__wrapper is-two-fifths"><a class="account__edit-link" @click.prevent="$router.push('/contact/general')">Edit General Contact</a></div>
                </div>
            </div>
            <div class="account__edit-item">
                <div class="columns is-mobile">
                    <div class="column account__edit-content">
                        <div v-if="supplier.technical && supplier.technical.email">
                            {{ supplier.technical.name }}<br>
                            {{ supplier.technical.jobTitle }}<br>
                            {{ supplier.technical.email }}<br>
                            {{ supplier.technical.phone }}
                        </div>
                    </div>
                    <div class="column account__edit-link__wrapper is-two-fifths"><a class="account__edit-link" @click.prevent="$router.push('/contact/technical')">Edit Coder Contact</a></div>
                </div>
            </div>
          </div>
          <div class="column is-offset-1 account__billing">
              <div class="box account__billing-box" v-if="supplier.paid === true || supplier.primary === true">
                  <h5 class="title is-6">Billing</h5>
                  <div class="columns">
                      <div class="column" v-if="supplier.primary !== true">
                          <p>You are paying £{{ parseInt(subscriptionValue) }} per month</p>
                          <hr class="account__billing-box__separator">
                          <p class="is-size-6">Commission paid via Stripe<br>(Monthly)</p>
                      </div>
                      <div class="column" v-else>
                        <p>You are a <b>Primary Partner</b>, saving £{{ parseInt(subscriptionValue) }} per month</p>
                      </div>
                      <div class="column is-one-third">
                          <a class="button account__billing-box__edit-btn is-fullwidth is-small is-outlined is-inverted" @click.prevent="$router.push('/payment')" v-if="!supplier.primary">Edit</a>
                      </div>
                  </div>
                  <div>
                    <a class="button account__billing-box__edit-btn is-fullwidth is-small is-outlined is-inverted" @click.prevent="$router.push('/billing')">Products & Billing</a>
                  </div>
              </div>
          </div>
        </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import api from '../libs/api';
import sendEvent from '../libs/sendEvent';
import EditableItem from '../components/editable-items/EditableItem.vue';

export default {
  name: 'account',
  data() {
    return {
      editing: false,
      editingTrading: false,
      thisAddress: "",
      thisAddressClean: "",
      thisTrading: "",
      thisTradingClean: "",
      billing: {},
      subscription: {},
      subscriptionValue: 75,
      supplier: {
        company: null,
        authorised: {
          name: '',
          email: '',
          jobTitle: '',
          phone: '',
        },
        general: {
          name: '',
          email: '',
          jobTitle: '',
          phone: '',
        },
        technical: {
          name: '',
          email: '',
          jobTitle: '',
          phone: '',
        },
      },
    };
  },
  components: {
    'editable-item': EditableItem
  },
  watch: {
    thisAddressClean: function() {
      this.thisAddress = this.thisAddressClean.replace(/\s?\,\s?/g,"<br>");
    },
    thisTradingClean: function() {
      this.thisTrading = this.thisTradingClean.replace(/\s?\,\s?/g,"<br>");
    },
    supplier: {
        handler: async function(newValue) {
          console.log('changed',newValue);
          await this.saveSupplier();
        },
        deep: true
    }
  },
  async created() {
    this.billing = await api({
      endpoint: `${process.env.VUE_APP_API}/billing`,
      path: '/billingpage',
      method: 'GET',
    });
    if (this.billing.tracks) {
      this.subscription = this.billing.tracks.filter(s => {
        return s.item.itemId == 'supplier-subscription'
      });
      if (this.subscription[0]){
        this.subscriptionValue = parseFloat(this.subscription[0].item.price);
      } else {
        this.subscriptionValue = 75;
      }
    }
    this.supplier = await api({
      endpoint: `${process.env.VUE_APP_API}/suppliers`,
      path: '/info',
      method: 'GET',
    });

    if (this.supplier.companyData && this.supplier.companyData.address_snippet) {
      this.thisAddress = this.supplier.companyData.address_snippet.replace(/\s?\,\s?/g,"<br>");
      this.thisAddressClean = this.supplier.companyData.address_snippet;
    }

    if (this.supplier.tradingName) {
      this.thisTrading = this.supplier.tradingName.replace(/\s?\,\s?/g,"<br>");
      this.thisTradingClean = this.supplier.tradingName;
    }
  },
  methods: {
    async saveSupplier() {
      await api({
        endpoint: `${process.env.VUE_APP_API}/suppliers`,
        path: '/',
        method: 'PUT',
        body: this.supplier,
      });
    },
    editAddress() {
      this.editing = true;
    },
    async editAddressSave() {
      this.supplier.companyData.address_snippet = this.thisAddressClean;
      //this.supplier.address = this.thisTradingClean;
      await this.saveSupplier();
      this.editing = false;
    },
    editTrading() {
      this.editingTrading = true;
    },
    async editTradingSave() {
      this.supplier.tradingName = this.thisTradingClean;
      await this.saveSupplier();
      this.editingTrading = false;
    }
  },
};
</script>

<style lang="scss">
.editable-item__btn-wrapper, .s3 input {
  display:none
}

.s3__button {
  margin-left: 25px;
    margin-right: 25px;
}

.card.company-card {
  max-width: 400px !important;
}

.user-details {
  max-width: 400px;
  margin: 0 auto;
}

.btn-next {
  margin-top: 20px;
}
</style>
